module.exports = __webpack_public_path__ + "img/test.cb499df9.jpg";